import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueTheMask from 'vue-the-mask'
import VueSimpleAlert from "vue-simple-alert";
import VueIntercom from 'vue-intercom';
import VuePromiseBtn from 'vue-promise-btn'
import ProgressBar from 'vuejs-progress-bar'
import VueTimers from 'vue-timers'
import VueIdentifyNetwork from 'vue-identify-network';
Vue.use(VueIdentifyNetwork);

Vue.use(ProgressBar)
Vue.use(VueTimers)

// not required. Styles for built-in spinner
import 'vue-promise-btn/dist/vue-promise-btn.css'




Vue.config.productionTip = false
Vue.config.devtools = false;

Vue.use(VueFormWizard)
Vue.use(VueTheMask)
Vue.use(VueSimpleAlert);
Vue.use(VueIntercom, { appId: 'naxtoq3z' });
Vue.use(VuePromiseBtn)
Vue.use(ProgressBar)


new Vue({
  router,
  store,
  vuetify,
  VueFormWizard,
  VueTheMask,
  VueSimpleAlert,
  VueIntercom,
  VuePromiseBtn,
  render: h => h(App)
}).$mount('#app')

